import "./Preloader.scss"

const Preloader = () => {
    return (
        <div className="preloader">
            <div className="progress">
                <div className="indeterminate"></div>
            </div>
        </div>
    )
}

export default Preloader